module.exports = __webpack_public_path__ + "static/media/preloader_01_01.08c8bbfe.gif";